import { Group, Vector3 } from "three";
import { DashedSingleLine } from "./DashedSingleLine.js";
export class LimitLine extends Group {
    constructor(viewType, color) {
        super();
        this._lineDir = new Vector3();
        this.interceptedByRaycaster = false;
        this.add(this._line = new DashedSingleLine("Line", color));
        this.visible = false;
    }
    updateLimit(linePos1, linePos2) {
        this.visible = true;
        this._lineDir.copy(linePos1).sub(linePos2).setLength(100000);
        this._line.setAB(this._line.A.copy(linePos1).add(this._lineDir), this._line.B.copy(linePos1).sub(this._lineDir));
    }
    clearLimit() {
        this.visible = false;
    }
}
//# sourceMappingURL=LimitLine.js.map